exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\r\n    display: inline-block;\r\n}\r\n\r\n.default{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: none;\r\n    color: #68748d;\r\n    background-color: #ced2db;\r\n    font-size: 0.75rem;\r\n    padding: 0;\r\n    outline: none;\r\n    z-index: 101;\r\n}\r\n\r\n.default.no-background{\r\n    background-color: transparent;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/close-btn.component/close-btn.component.css
// module id = ./src/app/shared/components/close-btn.component/close-btn.component.css
// module chunks = main